// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImpersonateButton_wrapper_2RLCN","icon":"ImpersonateButton_icon_2_iYf","text":"ImpersonateButton_text_C648b"};